import React, { useEffect, useState } from "react";
import "../App.css";

export default function ThreeRandomCards({ onClose }) {
  const [allCards, setAllCards] = useState([]);
  const [numCards, setNumCards] = useState(3);
  const [cards, setCards] = useState([]);
  const [guaranteedCard, setGuaranteedCard] = useState([]);
  const [selectedCardToAdd, setSelectedCardToAdd] = useState("");

  useEffect(() => {
    const fetchCards = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}api/data/snapAllCards`);
        const data = await res.json();

        const sorted = [...data].sort((a, b) =>
          a.cardname.localeCompare(b.cardname)
        );

        setAllCards(sorted);
        generateRandomCards(sorted, guaranteedCard, numCards);
      } catch (err) {
        console.error("Failed to fetch random cards:", err);
      }
    };

    fetchCards();
  }, []);

  const generateRandomCards = (
    data = allCards,
    guaranteed = guaranteedCard,
    count = numCards
  ) => {
    if (!data || data.length === 0) return;

    const numberToPick = Number(count);

    const guaranteedObjects = data.filter((card) =>
      guaranteed.includes(card.cardname)
    );

    const remainingPool = data.filter(
      (card) => !guaranteed.includes(card.cardname)
    );

    const shuffledRemaining = [...remainingPool].sort(() => 0.5 - Math.random());

    const selected = [
      ...guaranteedObjects,
      ...shuffledRemaining.slice(
        0,
        Math.max(0, numberToPick - guaranteedObjects.length)
      ),
    ].slice(0, numberToPick);

    setCards(selected);
  };

  const handleReroll = () => {
    generateRandomCards();
  };

  const handleNumCardsChange = (e) => {
    const value = Number(e.target.value);
    setNumCards(value);

    let updatedGuaranteed = guaranteedCard;

    if (guaranteedCard.length > value) {
      updatedGuaranteed = guaranteedCard.slice(0, value);
      setGuaranteedCard(updatedGuaranteed);
    }

    generateRandomCards(allCards, updatedGuaranteed, value);
  };

  const handleAddGuaranteedCard = () => {
    if (!selectedCardToAdd) return;
    if (guaranteedCard.includes(selectedCardToAdd)) return;
    if (guaranteedCard.length >= numCards) return;

    const updated = [...guaranteedCard, selectedCardToAdd];
    setGuaranteedCard(updated);
    setSelectedCardToAdd("");
    generateRandomCards(allCards, updated, numCards);
  };

  const handleRemoveGuaranteedCard = (cardName) => {
    const updated = guaranteedCard.filter((name) => name !== cardName);
    setGuaranteedCard(updated);
    generateRandomCards(allCards, updated, numCards);
  };

  const availableCards = allCards.filter(
    (card) => !guaranteedCard.includes(card.cardname)
  );

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{ textAlign: "center", position: "relative" }}
      >
        <button className="close-button" onClick={onClose}>
          ✕
        </button>

        <h2 className="results-heading" style={{ marginBottom: "16px" }}>
          Random Deck Starter
        </h2>

        <div style={{ marginBottom: "20px" }}>
          <label
            style={{
              color: "rgb(197,176,55)",
              fontWeight: "bold",
              marginRight: "8px",
            }}
          >
            Number of Cards:
          </label>

          <select
            id="numCards"
            value={numCards}
            onChange={handleNumCardsChange}
            className="navbar-select"
            style={{ width: "220px" }}
          >
            {Array.from({ length: 12 }, (_, i) => i + 1).map((num) => (
              <option key={num} value={num}>
                {num}
              </option>
            ))}
          </select>
        </div>

        <div style={{ marginBottom: "20px" }}>
          <label
            htmlFor="guaranteedCard"
            style={{
              color: "rgb(197,176,55)",
              fontWeight: "bold",
              display: "block",
              marginBottom: "10px",
            }}
          >
            Guaranteed Cards:
          </label>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "8px",
              flexWrap: "wrap",
              marginBottom: "12px",
            }}
          >
            <select
              id="guaranteedCard"
              value={selectedCardToAdd}
              onChange={(e) => setSelectedCardToAdd(e.target.value)}
              className="navbar-select"
              style={{ width: "260px" }}
            >
              <option value="">Select a card</option>
              {availableCards.map((card) => (
                <option key={card.id} value={card.cardname}>
                  {card.cardname}
                </option>
              ))}
            </select>

            <button
              className="modern-btn"
              type="button"
              onClick={handleAddGuaranteedCard}
              disabled={
                !selectedCardToAdd || guaranteedCard.length >= numCards
              }
            >
              Add
            </button>
          </div>

          <div style={{ marginBottom: "8px", color: "#ccc", fontSize: "14px" }}>
            {guaranteedCard.length} / {numCards} guaranteed selected
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "8px",
              flexWrap: "wrap",
              minHeight: "40px",
            }}
          >
            {guaranteedCard.length === 0 ? (
              <span style={{ color: "#999" }}>No guaranteed cards selected</span>
            ) : (
              guaranteedCard.map((cardName) => (
                <button
                  key={cardName}
                  type="button"
                  onClick={() => handleRemoveGuaranteedCard(cardName)}
                  style={{
                    background: "rgb(197,176,55)",
                    color: "#111",
                    border: "none",
                    borderRadius: "20px",
                    padding: "8px 12px",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                  title="Remove card"
                >
                  {cardName} ✕
                </button>
              ))
            )}
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "16px",
            flexWrap: "wrap",
            marginBottom: "20px",
          }}
        >
          {cards.length === 0 ? (
            <p>Loading random cards...</p>
          ) : (
            cards.map((card) => (
              <div
                key={card.id}
                style={{
                  background: "#222",
                  borderRadius: "10px",
                  padding: "12px",
                  width: "180px",
                  boxShadow: "0 0 10px rgba(255, 215, 0, 0.2)",
                }}
              >
                {card.cardhtml ? (
                  <img
                    src={card.cardhtml}
                    alt={card.cardname}
                    style={{
                      width: "100%",
                      borderRadius: "8px",
                      marginBottom: "8px",
                    }}
                  />
                ) : (
                  <div
                    style={{
                      background: "#333",
                      padding: "24px 0",
                      borderRadius: "8px",
                      marginBottom: "8px",
                      color: "#aaa",
                    }}
                  >
                    {card.cardname}
                  </div>
                )}
              </div>
            ))
          )}
        </div>

        <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
          <button className="modern-btn" onClick={handleReroll}>
            Reroll
          </button>
          <button className="modern-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}